import React,{useState} from 'react'
import { FaHome, FaBars ,FaThList} from 'react-icons/fa'
import { IoIosArrowBack } from 'react-icons/io'
import { Link, withRouter } from "react-router-dom";
import { ToggleLayer, Arrow } from 'react-laag';
import ResizeObserver from 'resize-observer-polyfill';
import { TopMenuLink } from './TopMenuLink';
const TopMenu = ({ history, location }) => {
    const [toggleLayerOpen, setToggleLayerOpen] = useState(false);
    const { pathname } = location;
    const iconSize = 30;
    const iconColor = 'white';
    const menus=[
        ['网上报名','/detail/80220'],
        ['准考证打印','http://webbm.zjks.com/webRegister/index.aspx?examKind=08'],
        ['培训平台','http://www.jxkp.net/'],
        ['成绩查询','/detail/80221'],
    ]
    const buildRightMenu=()=>{
        return (

                <ToggleLayer isOpen={toggleLayerOpen} ResizeObserver={ResizeObserver}
                    renderLayer={({ isOpen, layerProps, arrowStyle, layerSide }) =>
                        isOpen && (
                            <div
                                ref={layerProps.ref}
                                className="layer"
                                style={{
                                    ...layerProps.style,
                                    width: 156,
                                    height: 'auto',
                                    backgroundColor: "#fff",
                                    borderWidth: 1,
                                    borderColor: "#ddd",
                                    boxShadow: '0px 0px 4px #ddd'
                                }}
                            >
                                <div className='layer-menu-outer'>
                                    <TopMenuLink text='网上报名' url='/detail/80220' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='准考证打印' url='http://webbm.zjks.com/webRegister/index.aspx?examKind=08' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='培训平台' url='http://www.jxkp.net/' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='成绩查询' url='/detail/80221' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='报考条件' url='http://www.zjks.com/showinfo/MoreLmshow.aspx?pLmid=28&Lmid=276' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='合格证书' url='/list/49' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='考试计划' url='/detail/89081' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='联系我们' url='/detail/80168' onClicked={ setToggleLayerOpen} />
                                    <TopMenuLink text='表格下载' url='/detail/80167' onClicked={ setToggleLayerOpen} />
                                    {/* <div>
                                        <Link to='/aboutjs' onClick={() => setToggleLayerOpen(false)} >美丽嘉兴</Link>
                                    </div>
                                    <div>
                                        <Link to='/kclist' onClick={() => setToggleLayerOpen(false)} >所有课程</Link>
                                    </div> */}
                                    

                                </div>

                                <Arrow
                                    style={arrowStyle}
                                    layerSide={layerSide}
                                    backgroundColor="#fff"
                                    borderWidth={1}
                                    borderColor="#ddd"
                                    roundness={0.5}
                                />
                            </div>
                        )
                    }
                    placement={{
                        autoAdjust: true,
                        triggerOffset: 10
                    }}
                    onOutsideClick={() => setToggleLayerOpen(false)}
                >
                    {({ triggerRef }) => (
                        <div ref={triggerRef} onClick={() => setToggleLayerOpen(!toggleLayerOpen)}>

                            <FaBars size={iconSize} color={iconColor} />
                        </div>

                    )}

                </ToggleLayer>
        )
    }
    return (
        <>

            <div className='top-menu-wrap'>
                <Link to={'/'} >
                    <FaHome size={iconSize} color={iconColor} />
                </Link>
                {history.length > 0 && pathname !== '/' && (

                    <a onClick={() => history.goBack()} >
                        <IoIosArrowBack size={iconSize} color={iconColor} />
                    </a>
                )}
                <span className='name-txt'>嘉兴考试培训网</span>
               {buildRightMenu()}
            </div>
            
        </>
    )
};

export default withRouter(TopMenu)